/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/10/8 14:40
 * @FileName: contactUs.js
 * @LastEditor: 2022/10/8 14:40
 * @Name: contactUs
 */

const contactUs = {
  routes: [
    {
      path: '/contactUs',
      name: 'contactUs',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/contact-us/contact-us.vue')
    }
  ]
};
export default contactUs;



// WEBPACK FOOTER //
// ./src/project/router/contactUs.js